import React from 'react';
import { connect } from 'react-redux';
import { Trans } from 'react-i18next';
import * as R from 'ramda';
import { pageWrapper, EEventNames } from '../../../../../client/analytics';
import Container from '../../../../common/components/container';
import Overview from '../../../../common/components/overview';
import NetworkForm from '../../forms/network';
import * as networkSelector from '../../selectors/network';

const NetworkSettingsGeneral = ({ network }) => (
  <Container name="SettingsAdmins">
    <Container.Content>
      <Overview>
        <Overview.Header>
          <Overview.Header.Title><Trans i18nKey="network:settings_general_title" /></Overview.Header.Title>
        </Overview.Header>
        <Overview.Content>
          <NetworkForm initialValues={R.pick(['name'], network)} network={network} />
        </Overview.Content>
      </Overview>
    </Container.Content>
  </Container>
);

const mapStateToProps = (state) => ({
  network: networkSelector.selected(state),
});

export default connect(mapStateToProps)(pageWrapper(EEventNames.VISITED_NETWORK_GENERAL_SETTINGS_PAGE)(NetworkSettingsGeneral));
